import { brandedString } from 'src/helpers/brandedString';

/**
 * Global/module resources
 *
 * These are not bound to a resource instance `id` and can be fetched initially
 * at once.
 *
 * @todo: Ideally schema would expose them
 */
export const GLOBAL_RESOURCES = brandedString({
  APP: 'management-portal',
  APPLICATIONS_APP: 'applications:application',
  ORGS_ORGANIZATION: 'organizations:organization',
  TM_APPLICATION_LIST: 'tenant-management:application-list',
  TM_TENANT: 'tenant-management:tenant',
  USERS_USER: 'users:user',
});

export type GlobalResource =
  (typeof GLOBAL_RESOURCES)[keyof typeof GLOBAL_RESOURCES];
